<template>
  <footer v-if="isShowFooter">
    <ul>
      <li>
        <router-link :to="paperLink()" exact class="a-link" active-class="active">
          <i class="iconfont">&#xe663;</i>
          <br />
          <span>版面</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'News'}" class="a-link" active-class="active">
          <i class="iconfont">&#xe677;</i>
          <br />
          <span>目录</span>
        </router-link>
      </li>
    </ul>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NewsFooter",
  computed: {
    ...mapGetters(["isShowFooter","newspaper"])
  },
  methods: {
    paperLink() {
      if (Object.keys(this.newspaper).length > 0) {
        return {
          name: "PaperInfo",
          params: {
            id: this.newspaper.data.id
          }
        };
      } else {
        return {
          name: "Home"
        };
      }
    }
  }
};
</script>
